const state = {
  is_preview: true,
  result: {},
  listsCurrent: 0,
  tabView: "select2",
  mask: false,
};
const mutations = {
  is_preview(state, is_preview) {
    state.is_preview = is_preview;
  },
  result(state, result) {
    state.result = result;
  },
  listsCurrent(state, listsCurrent) {
    state.listsCurrent = listsCurrent;
  },
  tabView(state, tabView) {
    state.tabView = tabView;
  },
  mask(state, mask) {
    state.mask = mask;
  },
  changePassStatus(state) {
    state.result.chapter_list[state.listsCurrent].pass_status = "passed";
  },
};
const actions = {
  changePassStatus: (context) => {
    context.commit("changePassStatus");
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
